import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { WaitlistForm } from "./WaitlistForm";

const REVEAL = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};
const reveal = (delay = 0) => ({ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] });

export const BodyCare = () => (
  <section id="body-care" className="bg-[#EDE3D6] scroll-mt-28" data-testid="body-care-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-20 sm:py-28 grid lg:grid-cols-12 gap-12 items-center">
      <motion.div {...REVEAL} transition={reveal(0)} className="lg:col-span-7 order-2 lg:order-1">
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-4">Body Care</p>
        <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[#2B1F1B] leading-tight" data-testid="body-care-heading">
          Body Care, <span className="italic text-[#3A2A25]">Coming Soon.</span>
        </h2>
        <div className="mt-6 flex items-center gap-3">
          <h3 className="font-serif-display text-2xl text-[#2B1F1B]" data-testid="body-serum-name">CELUSTA Body Serum</h3>
          <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-[#3A2A25] text-[#EDE3D6] text-[10px] font-mono-accent uppercase tracking-[0.2em]" data-testid="body-serum-badge">
            <Clock size={11} strokeWidth={2} />
            Coming Soon
          </span>
        </div>
        <p className="mt-4 text-sm sm:text-base font-light text-[#756A64] leading-relaxed max-w-lg" data-testid="body-care-copy">
          A new everyday body-care essential is on the way. Join the list and be the first to know
          when it arrives.
        </p>
        <WaitlistForm
          product="body-serum"
          testIdPrefix="body-"
          buttonLabel="Be First to Know"
          promptLabel="Be first to know"
          className="mt-8 max-w-lg"
        />
      </motion.div>

      <motion.div {...REVEAL} transition={reveal(0.15)} className="lg:col-span-5 order-1 lg:order-2">
        <div className="rounded-2xl overflow-hidden border border-[rgba(58,42,37,0.1)] max-w-md mx-auto">
          <img
            src="/images/body-serum-placeholder.svg"
            alt="CELUSTA Body Serum — coming soon"
            loading="lazy"
            className="w-full h-auto"
            data-testid="body-serum-image"
          />
        </div>
      </motion.div>
    </div>
  </section>
);
